const Paths = Object.freeze({
	root: "/",
	explore: "/explore",
	notifications: "/notifications",
	sharedWithMe: "/shared",
	plans: "/plans",
	settings: "/settings",
	treeViewPattern: "/trees/:id",
	treeEditPattern: "/trees/:id/edit",
	treeFullViewPattern: "/trees/:id/view",
	userProfilePattern: "/users/:id",

	helpSupport: "/help",
	contact: "/contact",
	privacyPolicy: "/privacy-policy",
	termsOfService: "/terms-of-service",
	refundPolicy: "/refund-policy",
	cookiePolicy: "/cookie-policy",
	rightsPolicy: "/rights-policy",
	newsletterUnsubscribe: "/newsletter/unsubscribe",

	signIn: "/signin",
	signUp: "/register",
	forgotPassword: "/forgot-password",
	resetPassword: "/reset-password",
	verifyEmail: "/verify-email",

	notFound: "*"
});

export default Paths;
export const getTreeViewPath = (id: string): string => `/trees/${id}`;
export const getTreeEditPath = (id: string, entityId?: string): string =>
	entityId ? `/trees/${id}/edit?entity=${entityId}` : `/trees/${id}/edit`;
export const getTreeFullViewPath = (id: string, entityId?: string): string =>
	entityId ? `/trees/${id}/view?entity=${entityId}` : `/trees/${id}/view`;
export const getUserProfilePath = (userId: string): string => `/users/${userId}`;
